/**
 * User state helpers — single source of truth for active/inactive checks.
 *
 * The backend has two fields: `is_active` (boolean) and `lifecycle_state`
 * (string: 'active', 'suspended', 'deactivated', 'offboarded', 'invited').
 * They can desync. Every UI check must use these helpers, not raw field
 * comparisons, to ensure consistent behavior.
 */

/**
 * Returns true only if the user can log in and interact with the system.
 * Both is_active must be true AND lifecycle_state must be 'active' or 'invited'.
 */
export const isUserActive = (user) => {
  if (!user) return false;
  if (user.is_active === false) return false;
  const state = user.lifecycle_state || 'active';
  return state === 'active' || state === 'invited';
};

/**
 * Returns the lifecycle state for display, accounting for is_active desync.
 * If is_active is false, always show 'suspended' regardless of lifecycle_state.
 */
export const getUserStatus = (user) => {
  if (!user) return 'active';
  if (user.is_active === false) return 'suspended';
  return user.lifecycle_state || 'active';
};

const userHelpers = { isUserActive, getUserStatus };
export default userHelpers;
